module.exports = __webpack_public_path__ + "static/img/8.a156a2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-cn/8.jpg
// module id = RF3z
// module chunks = 1